import React, { useEffect } from 'react';
import * as S from './offer.styles';
import copyToClipboard from '@stencil/flights-utils/src/copy-to-clipboard';

const Offer = ({ isDweb = false, offers }) => {
  if (!offers || offers.length <= 0) {
    return null;
  }

  useEffect(() => {
    if (document) {
      const offerCodeClassEle = document.getElementsByClassName('DealWrap');
      if (offerCodeClassEle && offerCodeClassEle.length > 0) {
        for (let i = 0; i < offerCodeClassEle.length; i++) {
          const offerCode = offerCodeClassEle[i]
            .getElementsByClassName('OfferCode')[0]
            .innerHTML.trim();
          const copyCodeEle = offerCodeClassEle[i].getElementsByClassName('CopyOfferCode');
          if (offerCode && copyCodeEle) {
            const copyCodeEleId = document.getElementById(copyCodeEle[0].id);
            if (copyCodeEleId) {
              copyCodeEleId.addEventListener('click', () => {
                const code = offerCode || '';
                handleCopyCode(code);
                copyCodeEleId.classList.add('selected');
                copyCodeEleId.innerText = 'Code Copied';
                setTimeout(() => {
                  copyCodeEleId.classList.remove('selected');
                  copyCodeEleId.innerText = 'Copy Code';
                }, 1000 * 5);
              });
            }
          }
        }
      }
    }
  }, []);

  const handleCopyCode = text => {
    copyToClipboard(text);
  };

  return (
    <>
      {offers.map((offerHtml, index) => (
        <S.OfferBanner key={index} dangerouslySetInnerHTML={{ __html: offerHtml }}></S.OfferBanner>
      ))}
    </>
  );
};
export default Offer;
